import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteValueItem } from "../../api/apiValueItems";
import parseError from "../../utils/parseError";

export function useDeleteValueItem() {
    const queryClient = useQueryClient();

    const { mutate: deleteItemMutate, isPending } = useMutation({
        mutationFn: deleteValueItem,
        onSuccess: (response) => {
            toast.success(response.message || "Deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["value-items"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete value item");
        },
    });

    return { deleteItemMutate, isPending };
}
